module.exports = __webpack_public_path__ + "img/student-pic.b0753ebe.png";